module.exports = __webpack_public_path__ + "static/img/nav_bg_fixed.a5cf89e6.png";